import {getCurrentMerchant} from 'redux/modules/currentUser/selectors'

const freePlan = {
  id: 'free',
  amount: 0,
  currency: 'EUR',
  name: 'Free',
  metadata: {
    description: 'limited functionality'
  }
}

const enterprisePlan = {
  id: 'enterprise',
  name: 'Enterprise',
  currency: 'EUR',
  metadata: {
    limitNumber: 'unlimited'
  }
}

export function isOnManualPlan(state) {
  const plans = getPlans(state)
  const merchant = getCurrentMerchant(state)

  if (!plans || !merchant) return null

  const {activePlan} = merchant

  if (!activePlan || activePlan === 'free') return null

  return activePlan && !plans.map(p => p.id).includes(activePlan)
}

export function getPlans(state) {
  const {plans} = state.billing
  const merchant = getCurrentMerchant(state)

  if (!plans || !merchant) return null

  const allPlans = plans.concat([enterprisePlan, freePlan])
  const {activePlan} = merchant

  return allPlans.map(plan => {
    const {id} = plan
    if (activePlan && id === activePlan) {
      plan.active = true
    } else {
      plan.active = false
    }

    return plan
  })
}

export function getInvoices(state) {
  const {invoices} = state.billing

  if (!invoices) return null

  return invoices
}



// WEBPACK FOOTER //
// ./client/redux/modules/billing/selectors.js